<app-loader [isLoading]="isLoading"></app-loader>
<div *ngIf="!isLoading" style="background-color: #fff !important;height: 100%;">

  <div>
    <div class="col-sm-12 pt-5">
      <div *ngIf="addCartData.length==0" class="addCart-content">
        <div class="back-image "></div>
        <div class="empty-cart-content"> Your Shoping Cart is Empty Now </div>
        <div class="addcart-btn">
          <button class="btn btn-info btn-md btn-align-addcart" [routerLink]="['/dashboard']">
            Continue Shopping...
          </button>
        </div>
      </div>
    </div>
    <div class="addcrt-design d-flex pt-1" *ngFor="let cartData of addCartData">
      <div class="col-lg-2 col-md-2 col-2">
        <div class="zoom_left_inner_panel">
          <img #productImage class="product-image"
            style="width:50px;height:50px;object-fit: contain;border-radius: 8px;"
            src="{{imageBaseUrl + cartData?.image}}">
        </div>
      </div>
      <div class="col-lg-8 col-md-8 col-8">
        <div class="item-name">{{cartData.product_name | titlecase}}</div>
        <div class="item-mrp">
          ₹ <del>
            {{cartData.mrp}}
          </del>
          Save ₹ {{cartData.mrp-cartData.price}}
        </div>
        <div class="item-mrp">
          ₹ {{cartData.price}}
        </div>
        <div class="item-mrp" *ngIf="cartData?.size?.length > 0">
          Size : {{cartData.size}}
        </div>

        <div class="card-title_1" >Subtotal : ₹ {{cartData.price*cartData.quantity}} ({{cartData.quantity}} item)
        </div>

      </div>
      <div class="col-lg-2 col-md-2 col-2">
        <div class="quantity-btn-align">
          <nav aria-label="quantity-navigation">
            <ul class="pagination">
              <li class="page-item"><a class="page-link" (click)="decrement(cartData)"><strong
                    style="cursor: pointer;">-</strong></a>
              </li>
              <li class="page-item item-font"><a class="page-link qunt-back">{{cartData.quantity}}</a></li>
              <li class="page-item"><a class="page-link"
                  (click)="$event.stopPropagation();flyToCart(productImage);increment(cartData)"><strong
                    style="cursor: pointer;">+</strong></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
    <div class="col-md-12" *ngIf="addCartData.length>0">
      <div class="totalItemValue">
        <div class="totalAmount mb-3" *ngIf="showCartItems">Total : ₹ {{totalAmount.toFixed(2)}} </div>
        <button class="btn btn-info btn-rounded btn-md float-right" (click)="proceedBuyItem(addCartData)">Proceed to
          Buy</button>
      </div>
      <div class="checkUser pt-1 mb-4">
      </div>
      <br />
      <br />
      <br />
      <br />
      <br>
    </div>
  </div>
</div>